<template>
	<v-card>
		<v-card-title>
			<translate>
				Coverages
			</translate>
			<v-spacer />
			<v-progress-circular
				v-if="loading"
				:size="25"
				indeterminate
				color="primary"
			/>
		</v-card-title>
		<v-card-text>
			<v-row
				v-can="'productversion.update'"
			>
				<v-col class="d-flex align-center">
					<v-text-field
						v-model="coverage"
						:label="$gettext('New Coverage')"
						variant="outlined"
						hide-details
						:disabled="loading"
					/>
					<v-select
						v-model="language"
						:items="languages"
						item-value="id"
						item-title="name"
						class="ml-4"
						:label="$gettext('Template Language')"
						variant="outlined"
						:disabled="loading"
						hide-details
					/>
					<v-btn
						variant="text"
						color="primary"
						:disabled="loading"
						@click="postCoverage"
					>
						<translate>
							Create
						</translate>
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-skeleton-loader
						v-if="loading"
						type="table-thead, table-tbody"
					/>
					<v-table v-else>
						<thead>
							<tr>
								<th class="text-left">
									<translate>
										Language
									</translate>
								</th>
								<th class="text-left">
									<translate>
										Coverage
									</translate>
								</th>
								<th
									v-can="'productversion.update'"
									class="text-left"
								>
									<translate>
										Actions
									</translate>
								</th>
							</tr>
						</thead>
						<tbody>
							<!-- Newest first -->
							<tr
								v-for="item in coverages.slice().reverse()"
								:key="item.id"
							>
								<td>{{ item.language.name }}</td>
								<td>
									<v-text-field
										v-model:model-value="item.coverage"
										class="mt-2 mb-2"
										variant="outlined"
										density="compact"
										:readonly="!canEdit"
										hide-details
										@update:model-value="item.edited = true"
									/>
								</td>
								<td class="text-right">
									<div class="d-flex">
										<v-btn
											v-can="'productversion.update'"
											:disabled="!item.edited"
											variant="outlined"
											color="primary"
											class="mr-2"
											@click="putCoverage(item)"
										>
											<translate>
												Save
											</translate>
										</v-btn>
									</div>
								</td>
							</tr>
						</tbody>
					</v-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>
<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	props: {
		productVersionId: {
			required: true,
			type: Number,
		},
		languages: {
			required: true,
			type: Array,
		}
	},
	data () {
		return {
			loading: false,
			language: null,
			coverages: [],
			coverage: null,
		};
	},

	computed: {
		canEdit () {
			return JSON.parse(localStorage.getItem('permissions')).includes('productversion.update');
		}
	},
	mounted () {
		this.getCoverages();
	},

	methods: {
		/**
		 * Get all coverages for this product version
		 */
		getCoverages () {
			this.loading = true;
			axios.get(`/api/v0/coverages?productversion_id=${this.productVersionId}`).then(({
				data
			}) => {
				this.coverages = data;
			}).finally(() => {
				this.loading = false;
			});
		},

		/**
		 * Add a new coverage
		 */
		postCoverage () {
			this.loading = true;

			axios.post('/api/v0/coverages', {
				'coverage': this.coverage,
				'productversion_id': this.productVersionId,
				'language_id': this.language
			}).then(() => {
				this.getCoverages();
			}).finally(() => {
				this.loading = false;
			});
		},

		/**
		 * @param {object} item
		 */
		putCoverage (item) {
			this.loading = true;

			axios.put(`/api/v0/coverages/${item.id}`, {
				'id': item.id,
				'coverage': item.coverage,
				'productversion_id': item.productVersionId,
				'language_id': item.language.id
			}).then(() => {
				this.getCoverages();
			}).finally(() => {
				this.loading = false;
			});
		},
	}
};
</script>
<style scoped>
.v-table /deep/ table td:nth-child(2) {
	width: 100%;
}
</style>
